import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-xl lg:mx-auto pt-12 md:pt-12" }

import { computed, onMounted, ref, watchEffect } from 'vue';
import useWeb3 from '@/services/web3/useWeb3';
import { fNum } from '@/composables/useNumbers';
import { useXEmbr } from '@/embr/composables/stake/useXEmbr';

import { scale, scaleDown } from '@/lib/utils';
import { BigNumber } from 'bignumber.js';
import VeWaveTable from '@/components/tables/VeWaveTable/VeWaveTable.vue';
import XEmbrHeader from '@/embr/components/pages/xembr/XEmbrHeader.vue';
import BalTabs from '@/components/_global/BalTabs/BalTabs.vue';
//import useFarmUserQuery from '@/embr/composables/farms/useFarmUserQuery';
import XEmbrConvertWaveToVEWave from '@/embr/components/pages/xembr/XEmbrConvertWaveToVEWave.vue';
import useTokens from '@/composables/useTokens';
import { getAddress } from '@ethersproject/address';
//import useFarmUser from '@/embr/composables/farms/useFarmUser';
import usePoolWithFarm from '@/embr/composables/pool/usePoolWithFarm';
import BalAlert from '@/components/_global/BalAlert/BalAlert.vue';
import BalCard from '@/components/_global/BalCard/BalCard.vue';
import { useVEWave } from '../composables/stake/useVEWave';


export default _defineComponent({
  setup(__props) {

const { appNetworkConfig, isLoadingProfile, account } = useWeb3();
const {
  xEmbrLoading,
  userXembrBalance,
  userStakedEmbrBalance,
  userUnstakedEmbrBalance,
  totalEmbrStaking,
  totalXembrSupply,
  rewardTokens,
  totalCoolingSupply,
  cooldownUnits,
  cooldownTimestamp,
  cooldownPeriod,
  unstakeWindow
} = useXEmbr();

const { balanceFor, injectTokens, dynamicDataLoading, loading: tokensLoading } = useTokens();

/*const { farmUser, farmUserLoading } = useFarmUser(
  appNetworkConfig.xEmbr.farmId
);
*/
//const { pool, loadingPool } = usePoolWithFarm(appNetworkConfig.xEmbr.poolId);

/*
const xembrDeposited = computed(() => {
  const amount = farmUser.value?.amount;

  return amount ? scaleDown(new BigNumber(amount), 18) : new BigNumber(0);
});*/

function bn(num: number) {
  return new BigNumber(num);
}

const unstakedEmbrBalance = computed(() => {
  return fNum(scaleDown(new BigNumber(userUnstakedEmbrBalance.toString()), 18).toString(), 'token');
});

const hasUnstakedEmbr = computed(() => {
  return parseFloat(fNum(balanceFor(getAddress(appNetworkConfig.addresses.embr)), 'token')) > 0;
});

const hasCoolingEmbr = computed(() => {
  return cooldownUnits.value.gt(0);
});

const embrBalance = computed(() => fNum(balanceFor(getAddress(appNetworkConfig.addresses.embr)), 'token'));

const ONE_DAY = bn(86400);
const hasWithdrawableEmbr = computed(() => {
  const currentTime = bn(Date.now() / 1000);
  const totalTime = cooldownTimestamp.value.plus(cooldownPeriod.value);
  return cooldownUnits.value.gt(0) && currentTime.gt(totalTime) && currentTime.lt(totalTime.plus(unstakeWindow.value));
});

onMounted(() => {
  injectTokens([appNetworkConfig.xEmbr.address]);
});

const dataLoading = computed(
  () =>
    xEmbrLoading.value ||
    //farmUserLoading.value ||
    tokensLoading.value ||
    dynamicDataLoading.value
);

const tabs = [
  { value: 'deposit', label: 'Deposit' },
  { value: 'withdraw', label: 'Withdraw' }
];

const activeTab = ref(tabs[0].value);

// const {
//   getAllUserNFTs,
//   getAllStakedUserNFTsWithInfos
// } = useVEWave();

const userNftsUnstaked = ref();
const userNftsStaked = ref();

watchEffect(async () => {
  if (!account.value) return;

  // userNftsUnstaked.value = await getAllUserNFTs(account.value)
  // userNftsStaked.value = await getAllStakedUserNFTsWithInfos(account.value, )
});

// const userNftsUnstaked = computed(() => {
//       if (!account.value) return [];

//       const userNfts = getAllUserNFTs(account.value)

//       return userNfts
//     })

// const userNftsStaked = computed(() => {
//       if (!account.value) return [];

//       const userNfts = getAllStakedUserNFTsWithInfos(account.value)

//       return userNfts
//     })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(XEmbrHeader)
  ]))
}
}

})